'use strict';
/**
 * 許可MIME_TYPE
 *
 * */
export const MIME_TYPE = [
  'application/pdf',
  'application/msword',
  'application/x-zip-compressed',
  'application/zip',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

/**
 * AXIOS用のヘッダー
 *
 * */
export const AXIOS_HEADERS = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'X-Requested-With': 'XMLHttpRequest',
};

/**
 * UILock
 *
 * */
export const uiLock = (lock = true) => {
  if (lock) {
    document.getElementsByTagName('body')[0].classList.add('ui-lock');
  } else {
    document.getElementsByTagName('body')[0].classList.remove('ui-lock');
  }
};

/**
 * なめらかスクロール
 *
 * */
export const pageScroll = (to = 0) => {
  const EaseOutExpo = (t, b, c, d) => {
    return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
  };
  const padding = document.querySelector('.header').clientHeight;
  const start = Date.now();
  var to = to ? to - padding : document.querySelector('html').getBoundingClientRect().top;
  var from = document.querySelector('html').scrollTop;
  (function loop() {
    var c = Date.now() - start;
    if (c < 1000) {
      window.scrollTo(0, EaseOutExpo(c, from, to, 1000));
      window.requestAnimationFrame(loop);
    } else {
      window.scrollTo(0, to + from);
    }
  })();
};

/**
 * 郵便番号形式をチェック
 *
 * */
export const isPostalCode = (number = null) => {
  if (number && number.match(/^\d{3}-?\d{4}$/)) {
    return true;
  } else {
    return false;
  }
};

/**
 * 値の一致をチェック
 *
 * */
export const tryEqual = (
  nameLeft = null,
  nameRight = null,
  alertText = '入力内容を確認して下さい。'
) => {
  if (!nameLeft || !nameRight) {
    alert(alertText);
    throw new Error();
  }

  const leftValue = document.querySelector(`[name="${nameLeft}"]`).value;
  const rightValue = document.querySelector(`[name="${nameRight}"]`).value;
  if (leftValue != rightValue) {
    alert(alertText);
    document.querySelector(`[name="${nameRight}"]`).focus();
    throw new Error();
  }
};
